import React, {Component} from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import MissionSection from "./MissionSection";
import TimelineSection from "./TimelineSection";
import TeamSection from "./TeamSection";
import {connect} from "react-redux";

function mapStateToProps(state) {
    return {
        mobile: state.userReducer.mobile,
    }
}

class About extends Component {

    render() {
        return (
            <div className='col-plain'>
                <div className='col-ac pt-100'
                     style={{minHeight: '100vh', padding: this.props.mobile ? '80px 24px' : '0 10vw 10vh 10vw'}}>
                    <div className='col-plain mt-100'>
                        <MissionSection mobile={this.props.mobile}/>
                        <TimelineSection mobile={this.props.mobile}/>
                        <TeamSection mobile={this.props.mobile}/>
                        {/*<VideoSeciton mobile={this.state.mobile}/>*/}
                    </div>
                </div>
            </div>
        )
    }

}


export default connect(mapStateToProps)(About);
